import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/yeppy/design_back.png";

const Userexperienceyeppy = () => {
  return (
    <div
      className="userexperience_yeppy p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
            <h2>User Experience Mapping</h2>
            <h4>User Persona: Aisha Khan</h4>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <p>
              Empathy mapping helps you understand your user persona's emotions,
              behaviors, and needs more deeply.
            </p>
            <p>Here's an empathy map for Aisha Khan, the housewife</p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="user_box_yeppy">
              <h4>Says</h4>
              <ul>
                <li>
                  "I wish there was an easier way to do grocery shopping with my
                  kids around".
                </li>
                <li>
                  "I'm always in a rush, and taking my children to the store can
                  be so stressful."
                </li>
                <li>
                  "I'm concerned about finding quality groceries without
                  overspending."
                </li>
              </ul>
            </div>
            <div className="user_box_yeppy">
              <h4>Does</h4>
              <ul>
                <li>
                  Searches online for home delivery services and discounts.
                </li>
                <li>
                  Manages her children's needs while trying to accomplish
                  household tasks.
                </li>
                <li>Creates shopping lists to stay organized</li>
              </ul>
            </div>
            <div className="user_box_yeppy">
              <h4>Pain Points</h4>
              <ul>
                <li>
                  Time-consuming trips to physical stores with young children.
                </li>
                <li>Difficulty managing both household tasks and childcare.</li>
                <li>Concerns about overspending on groceries.</li>
                <li>
                  A desire for a secure and convenient way to shop for
                  essentials.
                </li>
              </ul>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="user_box_yeppy">
              <h4>Thinks</h4>
              <ul>
                <li>"I need a solution that can save me time and energy."</li>
                <li>
                  "Online grocery shopping might be the answer, but it needs to
                  be user-friendly."
                </li>
                <li>"I want to ensure my family's safety and budget."</li>
              </ul>
            </div>
            <div className="user_box_yeppy">
              <h4>Feels</h4>
              <ul>
                <li>
                  Frustrated by the challenges of going to physical stores with
                  young kids.
                </li>
                <li>
                  Stressed about managing time for both housework and childcare.
                </li>
                <li>Anxious about her family's financial well-being.</li>
              </ul>
            </div>
            <div className="user_box_yeppy">
              <h4>Gains</h4>
              <ul>
                <li>A solution that saves her time and reduces stress.</li>
                <li>Access to quality groceries and household items.</li>
                <li>
                  Budget-friendly options and savings through discounts and
                  deals.
                </li>
                <li>
                  A sense of security and relief in managing her family's needs
                  more efficiently.
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Userexperienceyeppy;
